import { useMutation } from "@tanstack/react-query";
import { CreateBookingExtraFormData } from "../schema/CreateBookingExtraSchema";
import { BookingExtraResponse, BookingExtraResponseSchema } from "../response/CreateBookingExtraResponse";
import { privateApi } from "../../../api/api";

const API_VERSION = "v4";

const createBookingExtra = async (formData: CreateBookingExtraFormData): Promise<BookingExtraResponse> => {
    const response = await privateApi.post(`/${API_VERSION}/booking-extra`, formData);
    return BookingExtraResponseSchema.parse(response.data);
}

export const useCreateBookingExtra = () => {
    return useMutation({
        mutationFn: createBookingExtra,
        onError: (error) => {
            console.error('Error creating booking extra:', error);
        }
    });
}
